import React from 'react'
import './Profile.css'
import ProfileAuthorCard from './ProfileAuthorCard'
import ProfileAuthorNavCard from './ProfileAuthorNavCard'


function Profile() {
    return (
        <div className="container">
            <div className="appProfile">
                <ProfileAuthorCard />
                <ProfileAuthorNavCard />
            </div>
        </div>
    )
}

export default Profile
